module.exports = __webpack_public_path__ + "static/media/analysis-profile.07bf8c2f.svg";